function pnSwiperA11y() {
 const copy = JSON.parse(document.getElementById('pn-original-product-data').textContent).interface;
 return {prevSlideMessage:copy.previous_slide,nextSlideMessage:copy.next_slide,
 firstSlideMessage:copy.first_slide,lastSlideMessage:copy.last_slide,
 paginationBulletMessage:copy.go_to_slide.replace('{number}','{{index}}'),
 slideLabelMessage:copy.slide_position.replace('{number}','{{index}}').replace('{total}','{{slidesLength}}')};
}
try {

  document.addEventListener('DOMContentLoaded', function () {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 749) {
      let lastState = null;

      function handleScroll() {
        const orderNowSection = document.getElementById('order-now-section');
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const hideOffset = 200;

        const stickyAtc = document.querySelectorAll('.sticky-atc');
        const headerWrapper = document.querySelectorAll('.header-wrapper');

        let isInOrderSection = false;
        if (orderNowSection) {
          const orderNowOffset = orderNowSection.getBoundingClientRect().top + window.scrollY;
          const orderNowHeight = orderNowSection.offsetHeight;

          isInOrderSection =
            scrollPosition + windowHeight / 2 > orderNowOffset - hideOffset &&
            scrollPosition < orderNowOffset + orderNowHeight;
        }

        const shouldShow = scrollPosition > 350 && !isInOrderSection;

        if (shouldShow && lastState !== 'visible') {
          lastState = 'visible';
          fadeIn(stickyAtc, 1000);
          fadeOut(headerWrapper, 1000);
        } else if (!shouldShow && lastState !== 'hidden') {
          lastState = 'hidden';
          fadeOut(stickyAtc, 500);
          fadeIn(headerWrapper, 500);
        }
      }

      window.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    function fadeIn(elements, duration) {
      elements.forEach(function (el) {
        clearTimeout(el.pnFadeTimer); el.dataset.pnFadeTarget = 'visible'; el.style.display = 'block';
        el.style.transition = `opacity ${duration}ms`;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (el.dataset.pnFadeTarget === 'visible') el.style.opacity = '1';
          });
        });
      });
    }

    function fadeOut(elements, duration) {
      elements.forEach(function (el) {
        el.style.transition = `opacity ${duration}ms`;
        clearTimeout(el.pnFadeTimer); el.dataset.pnFadeTarget = 'hidden'; el.style.opacity = '0'; el.pnFadeTimer = setTimeout(function () { if (el.dataset.pnFadeTarget === 'hidden') el.style.display = 'none';
        }, duration);
      });
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.testimonials-2-template--25467722170688__testimonials_VHC4an');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.testimonials-2-template--25467722170688__testimonials_VHC4an .testimonials-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: 3 > 3,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".testimonials-2-template--25467722170688__testimonials_VHC4an .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.testimonials-2-template--25467722170688__testimonials_VHC4an .swiper-button-next',
          prevEl: '.testimonials-2-template--25467722170688__testimonials_VHC4an .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.steps-slider-template--25467722170688__steps_slider_L4zdN9');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.steps-slider-template--25467722170688__steps_slider_L4zdN9 .steps-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".steps-slider-template--25467722170688__steps_slider_L4zdN9 .swiper-pagination",
          clickable: true
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.querySelectorAll('.faq-image-template--25467722170688__faq_image_zMbiG6 .question-header').forEach((header, index) => {
    // Open first question by default
    if (index === 0) {
      header.closest('.question-item').classList.add('active');
    }

    header.addEventListener('click', () => {
      const item = header.closest('.question-item');
      const wasActive = item.classList.contains('active');
      
      // Close all items
      document.querySelectorAll('.faq-image-template--25467722170688__faq_image_zMbiG6 .question-item').forEach(item => {
        item.classList.remove('active');
      });
      
      // Toggle clicked item
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.reviews-carousel-template--25467722170688__reviews_carousel_9YkpPA');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.reviews-carousel-template--25467722170688__reviews_carousel_9YkpPA .reviews-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 32,
        loop: true,
        pagination: {
          el: ".reviews-carousel-template--25467722170688__reviews_carousel_9YkpPA .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.reviews-carousel-template--25467722170688__reviews_carousel_9YkpPA .swiper-button-next',
          prevEl: '.reviews-carousel-template--25467722170688__reviews_carousel_9YkpPA .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.trustpilot-slider-template--25467722170688__trustpilot_slider_KiDGW3');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.trustpilot-slider-template--25467722170688__trustpilot_slider_KiDGW3 .trustpilot-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: 4 > 6,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".trustpilot-slider-template--25467722170688__trustpilot_slider_KiDGW3 .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.trustpilot-slider-template--25467722170688__trustpilot_slider_KiDGW3 .swiper-button-next',
          prevEl: '.trustpilot-slider-template--25467722170688__trustpilot_slider_KiDGW3 .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.querySelectorAll('.faq-image-bg-template--25467722170688__faq_image_bg_YFptC9 .question-header').forEach((header, index) => {
    // Open first question by default
    if (index === 0) {
      header.closest('.question').classList.add('active');
    }

    header.addEventListener('click', () => {
      const question = header.closest('.question');
      const wasActive = question.classList.contains('active');
      
      // Close all questions
      question.closest('.questions').querySelectorAll('.question').forEach(q => {
        q.classList.remove('active');
      });

      // Toggle clicked question
      if (!wasActive) {
        question.classList.add('active');
      }
    });
  });

} catch(error) { console.warn("Original section interaction", error); }